export const Y_HEIGHT = 32;
export const X_POSITION_SIGNIFICANT_RECT_GLR = 145;
export const X_POSITION_SIGNIFICANT_LABEL_GLR = 163;
export const X_POSITION_NOT_SIGNIFICANT_RECT_GLR = 252;
export const X_POSITION_NOT_SIGNIFICANT_LABEL_GLR = 270;
export const X_POSITION_SIGNIFICANT_RECT_VLR = 159;
export const X_POSITION_SIGNIFICANT_LABEL_VLR = 177;
export const X_POSITION_NOT_SIGNIFICANT_RECT_VLR = 266;
export const X_POSITION_NOT_SIGNIFICANT_LABEL_VLR = 284;
